import React, { useCallback } from "react";
import { useHistory, useLocation } from "react-router-dom";
import { Box, BoxProps } from "@material-ui/core";
import { AlertBlock } from "../../../components/AlertBlock";

export const SuccessNotification: React.FC<BoxProps> = ({ ...props }) => {
  const history = useHistory();
  const location = useLocation<{ success?: string } | undefined>();

  const onClose = useCallback(() => {
    history.replace(location.pathname);
  }, [history, location]);

  if (!location?.state?.success || typeof location.state.success !== "string") {
    return null;
  }

  return (
    <Box mb={4} {...props}>
      <AlertBlock
        variant="success"
        messages={[location.state.success]}
        onClose={onClose}
      />
    </Box>
  );
};
